export const sosFunctions = {
    getSosChartNumberFromPractices: (practices) => {
        if (practices && practices.length) {
            let sos = practices.find(item => item.practice_id == 9)
            if (sos) {
                return sos.chart_number
            }
        }
        return null
    }
}